import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import { ListGroupItem, Badge } from 'react-bootstrap';
import { useStyles } from '../../../styles/mapStylesCustom';

import { areLayersOverlayed } from '../../../api/Maps/map-operations';
import * as layerOps from '../../../api/Layers/layer-operations';

const LayersInMapList = ({
  layerItem,
  map,
  moveLayerUp,
  moveLayerDown,
  isLayer,
  isBaseMap,
  isDefaultBaseMap,
  makeDefaultBaseMap
}) => {
  if (isLayer) {
    if (areLayersOverlayed(map)) {
      return (
        <ListGroupItem>
          {layerOps.getName(layerItem)}{' '}
          {layerOps.isJoin(layerItem)
            ? `(${layerOps.getType(layerItem)})`
            : `(${layerOps.getSubType(layerItem)})`}
          <span className="float-right">
            <FontAwesomeIcon
              icon="chevron-circle-up"
              size="lg"
              style={{ cursor: 'pointer' }}
              onClick={() => moveLayerUp(layerOps.getId(layerItem))}
            />
            <FontAwesomeIcon
              icon="chevron-circle-down"
              size="lg"
              style={{ cursor: 'pointer' }}
              onClick={() => moveLayerDown(layerOps.getId(layerItem))}
            />
          </span>
        </ListGroupItem>
      );
    }
    return (
      <ListGroupItem>
        {layerOps.getName(layerItem)} ({layerOps.getSubType(layerItem)})
      </ListGroupItem>
    );
  }
  if (isBaseMap) {
    const classes = useStyles();
    let clickAction = () => makeDefaultBaseMap(layerOps.getId(layerItem));
    if (isDefaultBaseMap) {
      clickAction = () => console.error('This is defatul base map');
    }
    return (
      <ListGroupItem action onClick={clickAction} className="d-flex flex-wrap align-items-center">
        <span>
          {layerOps.getName(layerItem)} ({layerOps.getSubType(layerItem)})
        </span>
        {isDefaultBaseMap && (
          <Badge className={`ml-auto ${classes.azulIpsilumBackground}`}>default</Badge>
        )}
      </ListGroupItem>
    );
  }
  return '';
};

LayersInMapList.defaultProps = {
  moveLayerUp: () => console.error('no map to move'),
  moveLayerDown: () => console.error('no map to move'),
  isDefaultBaseMap: false,
  isBaseMap: false,
  isLayer: false,
  makeDefaultBaseMap: () => console.error('no map to make default')
};

LayersInMapList.propTypes = {
  layerItem: PropTypes.object.isRequired,
  map: PropTypes.object.isRequired,
  moveLayerUp: PropTypes.func,
  moveLayerDown: PropTypes.func,
  isBaseMap: PropTypes.bool,
  isLayer: PropTypes.bool,
  isDefaultBaseMap: PropTypes.bool,
  makeDefaultBaseMap: PropTypes.func
};

export default LayersInMapList;
